var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovilFondoGracias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 418,
    height: 812,
    viewBox: "0 0 418 812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 812,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-968.354 -1140.389)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 3.068,
    transform: "translate(1082.686 1718.197)",
    fill: "none",
    stroke: "#dfded2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.068,
    transform: "translate(1084.22 1716.663)",
    fill: "none",
    stroke: "#dfded2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.089,
    y2: 2.246,
    transform: "translate(1083.175 1717.074)",
    fill: "none",
    stroke: "#dfded2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.089,
    x2: 2.246,
    transform: "translate(1083.096 1717.152)",
    fill: "none",
    stroke: "#dfded2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.968 593.347) rotate(-22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1024.349,2715.038c27.853,3.623,52.243,22.011,56.91,50.172,3.357,20.255-.811,31.851-8.319,40.8-11.524,13.739-31.171,20.673-41.914,43.675-17.554,37.581,42.593,75.277,65.3,31.714",
    transform: "translate(1162.106 -2635.297)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1247.771,2646.619c9.74-35.056,47.5-75.1,83.963-55.946s51.6,54.905,48.8,90.887-29.058,71.036-59.976,53.04c-14.027-8.166-13.95-30.352-3.823-43.037a76.994,76.994,0,0,1,59.06-26.768",
    transform: "translate(1247.771 -2585.709)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.589 165.946) rotate(-95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.4,2804.2a56.735,56.735,0,0,0,3.641,6.872c26.112,43.51-6.836,91.886-61.165,69.344-48.385-20.076-8.159-88.939,34.675-84.145,71.847,2.717,99.28,102.145,52.249,150.554",
    transform: "translate(-83.822 -2722.342)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.069,2811.248c31.8-47.513,35.91-138.555-24.607-163.925-42.375-12.467-75.123,29.284-67.553,67.628",
    transform: "translate(-162.129 -2645.076)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.178,2814.6",
    transform: "translate(-167.944 -2731.842)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 395.516, 686.86)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 84.885,
    transform: "translate(0 42.443)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 84.885,
    transform: "translate(42.442 0)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 57.807,
    y2: 62.16,
    transform: "translate(13.539 11.363)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 57.807,
    x2: 62.16,
    transform: "translate(11.363 13.539)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.241 540.227)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 28.855,
    transform: "translate(0 14.428)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 28.855,
    transform: "translate(14.428)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 19.651,
    y2: 21.13,
    transform: "translate(4.602 3.863)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 19.651,
    x2: 21.13,
    transform: "translate(3.863 4.602)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.742 150.446)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 48.245,
    transform: "translate(0 24.122)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 48.245,
    transform: "translate(24.122)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 32.855,
    y2: 35.329,
    transform: "translate(7.695 6.458)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 32.855,
    x2: 35.329,
    transform: "translate(6.458 7.695)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.896 268.731)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("line", {
    x2: 5.382,
    transform: "translate(0 2.691)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.382,
    transform: "translate(2.691)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 3.665,
    y2: 3.941,
    transform: "translate(0.858 0.72)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.665,
    x2: 3.941,
    transform: "translate(0.72 0.858)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.164 -10)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 23.672,
    transform: "translate(0 11.836)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 23.672,
    transform: "translate(11.836)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 16.121,
    y2: 17.334,
    transform: "translate(3.776 3.169)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 16.121,
    x2: 17.334,
    transform: "translate(3.169 3.776)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1004.686 -952.935)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 0.271,
    transform: "translate(1082.686 1716.799)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.271,
    transform: "translate(1082.822 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.185,
    y2: 0.199,
    transform: "translate(1082.729 1716.7)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.185,
    x2: 0.199,
    transform: "translate(1082.722 1716.707)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovilFondoGracias);
export default __webpack_public_path__ + "static/media/movil_fondo_gracias.479b752adb152a15a130e8f2f68df3ba.svg";
export { ForwardRef as ReactComponent };